import './site-search-style.scss';

document.addEventListener( 'DOMContentLoaded', init );
function init() {

    const searchTrigger = document.querySelectorAll('.site-header-trigger');
    const searchArea    = document.querySelector( '.site-search' );
    [...searchTrigger].forEach( trigger => {
        trigger.addEventListener( 'click', toggleSearch );
        document.querySelector('.site-header-group').classList.remove('active');
    });
    
    function toggleSearch(event) {
        event.target.classList.toggle('active');
        searchArea.classList.toggle('active');
        document.body.classList.toggle('site-search-active');
    }

    const searchClose = searchArea.querySelector('.close-search');
    searchClose.addEventListener( 'click', closeSearch);

    function closeSearch(event) {

        if ( typeof event === undefined ) {
            event.target.classList.remove('active');
        }
        
        searchArea.classList.remove('active');
        document.body.classList.remove('site-search-active');
    }

    document.addEventListener( 'keydown', function(evt) {

        evt = evt || window.event;
        if ( evt.key === "Escape" || evt.key === "Esc" ){
            closeSearch();
        }
    });
}